//import { forEach } from "@angular/router/src/utils/collection";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AlertService } from "../../services/alert.service";
import { ToastrService } from "ngx-toastr";
import { logbaseService } from "../../services/logbase.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Location } from "@angular/common";
import { Subject } from "rxjs";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef
} from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: "app-user-activation",
  templateUrl: "./user-activation.component.html",
  styleUrls: ["./user-activation.component.scss"]
})
export class UserActivationComponent implements OnInit, OnDestroy {
  deliveryPointsHideArray: any = [];
  deliveryPointCheck: boolean = false;
  deliveryPointlistItem: any = [];
  showOPMSupplierCode: boolean = false;
  deliveryPointOPM: boolean = false;
  showSingleSelect: boolean;
  showMultipleSelect: boolean;
  opTypeRequired: boolean;
  operationTypeDropdown: boolean;
  supplierCodeReqFlag: boolean;
  suppliercodeDropdown: boolean;
  suppCodeRequired: boolean;
  nextProcessRequired: boolean;
  delPointSuppCodeDropdown: boolean;
  l4Selected: boolean;
  length: any;
  displayUntagAlert: boolean;
  supplierCode: any;
  userDataRolesList: any;
  userRolesList: any;
  userOperationType: any;
  selectedOperationType: any;
  supplierLoginId: any;
  supplierError: boolean;
  taggedSupplierCode: any;
  taggedSupplier: any;
  emailPattern: string;
  phonePattern: any;
  private onDestroy$ = new Subject<boolean>();
  userAccess: boolean;
  savedisabledSMADmin: boolean;
  userRoleMap: any;
  operationsUsers: any[];
  operationsList: any;
  LogisticsUsers: any[];
  LogisticsList: any;
  SMVSUsers: any;
  SMVSList: any;
  SMQUsers: any;
  SMQList: any;
  userIDTaken: boolean;
  roleArray: any[];
  roleIdArray: any[];
  itemSelected: any[];
  deliveryPointlink: any[];
  lineCodeList: any[];
  groupNumberList: any[];
  lineCodes: any;
  groupNumbers: any;
  supplierCodes: any;
  suppCodeList: any = [];
  deliveryPointList: any = [];
  userRoleID: any;
  user: any;
  userDetails: any;
  settings2: {
    singleSelection: boolean;
    text: string;
    enableSearchFilter: boolean;
  };
  settings: {
    singleSelection: boolean;
    text: string;
    selectAllText: string;
    unSelectAllText: string;
    enableSearchFilter: boolean;
  };
  selectedItems: {}[];
  itemList: { id: number; itemName: string }[];
  roleName: any;
  roleId: any;
  system: any;
  getSupplierCode: any;
  packagingPropertyOpt: string[];
  model: any = {};
  loading = false;
  isCopyShow = false;
  sub: any;
  modalRef: NgbModalRef;

  suppCodesettings:any
  suppCodesettings2:any

  userRoleSettings:any

  lineNumbersettings:any
  supplierCodeOpmsettings :any

  groupNumbersettings:any

  SMQSettings:any
  SMVSSettings :any
  LogisticsSettings:any
  operationsSettings:any
  operationsGNumberList = [
    { id: 0, itemName: "HO (Higashi Ogishima)" },
    { id: 1, itemName: "K1" }
  ];

  operationTypes = [
    { displayName: "Supplier To Supplier", value: "suppliertosupplier" },
    { displayName: "Fuso Operations", value: "fusooperations" }
  ];

  // add reference of the template
  @ViewChild("userUpdation") userUpdation: any;
  suppCodeApp: any;
  suppCodeSelect: any;
  suppCodeOPMSelect: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: logbaseService,
    private toastr: ToastrService,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private location: Location,
    private modalService: NgbModal,
    private translate: TranslateService
  ) { 
    this.suppCodesettings= {
      // singleSelection: false,
      // text: "Supplier Code",
      // enableSearchFilter: true
      singleSelection: false,
      text: "Select Supplier Code",
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      // classes: "custom-class
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.suppCodesettings2= {
      singleSelection: true,
      text: "Select Supplier Codes",
      enableSearchFilter: true,
      idField: 'id',
      textField: 'itemName'
    };
    this.userRoleSettings = {
      singleSelection: false,
      text: "Select User Roles",
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      // classes: "custom-class
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.lineNumbersettings = {
      singleSelection: false,
      text: "Select Next Process",
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      // classes: "custom-class
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.supplierCodeOpmsettings= {
      singleSelection: false,
      text: "Select Delivery Point",
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      // classes: "custom-class
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.groupNumbersettings = {
      singleSelection: false,
      text: "Group Number",
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      // classes: "custom-class
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.SMQSettings = {
      singleSelection: false,
      text: "SMQ",
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      // classes: "custom-class
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.SMVSSettings= {
      singleSelection: false,
      text: "SMVS",
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      // classes: "custom-class
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.LogisticsSettings= {
      singleSelection: false,
      text: "SMVS",
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      // classes: "custom-class
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
    this.operationsSettings = {
      singleSelection: false,
      text: "Operations",
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      // classes: "custom-class
      itemsShowLimit: 10,
      idField: 'id',
      textField: 'itemName'
    };
  }

  ngOnInit() {
    if (!this.model.operationType || this.model.operationType == 'Select') {
      this.model.operationType = 'Fuso Operations';
    }
    this.emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$";
    this.phonePattern = "^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]{1,12}$";

    this.opTypeRequired = false;
    this.suppCodeRequired = false;
    // this.suppliercodeDropdown = true;
    // this.nextProcessRequired = false;

    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    this.userRoleID = userDetJson.userRoleMappings[0].roleId;
    if (this.userRoleID == 8) {
      this.packagingPropertyOpt = ["Supplier", "SMQ", "SMVS"];
    } else if (this.userRoleID == 9) {
      this.packagingPropertyOpt = ["Logistic", "Operation", "LSP"];
    } else if (this.userRoleID == 5) {
      this.packagingPropertyOpt = [
        "Supplier",
        "SMQ",
        "Logistic",
        "Operation",
        "Admin",
        "SMVS",
        "SM Admin",
        "Logistic Admin",
        "Assembly Operator",
        // "Line Worker",
        "Level-4 Manager",
        "LSP"
      ];
    }
    this.spinner.show();
    // set check flags

    // Get package id to get all other details
    this.userDetails = this.route.snapshot.params["id"];
    this.userRoleMap = this.route.snapshot.params["rolename"];
    this.savedisabledSMADmin = false;
    this.userAccess = false;
    if (
      this.userRoleID == 8 &&
      (this.userRoleMap == 3 || this.userRoleMap == 4)
    ) {
      this.userAccess = true;
    } else if (
      this.userRoleID == 9 &&
      (this.userRoleMap == 3 || this.userRoleMap == 4)
    ) {
      this.userAccess = true;
    } else {
      this.userAccess = false;
    }

    // this.userDetails = this.route.snapshot.params["id"];
    this.userIDTaken = false;

    // if (
    //   this.model.lineNumbers == [] ||
    //   this.model.supplierCode == [] ||
    //   this.model.userRolesList == []
    // ) {
    //   this.userIDTaken = true;
    // } else {
    //   this.userIDTaken = false;
    // }

    this.userService
      .singlegetUserDetails(this.userDetails)
      .subscribe(result => {
        this.spinner.show();
        //Get parts data from URL and bind in form fields
        this.user = result.response;
        let userRolemapping = [];
        userRolemapping = this.user.userRoleMappings;
        this.roleIdArray = userRolemapping.map(obj => obj.userRole.roleId);
        if (this.roleIdArray.includes(4)) {
          this.opTypeRequired = true;
          this.supplierCodeReqFlag = true;
          this.showOPMSupplierCode = true;
          this.deliveryPointOPM = true;
        }

        this.model.operationGroupNumber = this.user.opGroupIds;
        this.model.loginId = this.user.loginId;
        this.model.employeeId = this.user.employeeId;
        this.model.firstName = this.user.firstName;
        this.model.lastName = this.user.lastName;
        this.model.employeeName = this.user.employeeName;
        this.model.companyname = this.user.companyName;
        this.model.emailId = this.user.emailId;
        this.model.phone = this.user.phone;
        this.model.password = this.user.password;

        //this.model.userrolemapping = this.user.userRoleMappings.roleName;
        this.roleArray = userRolemapping.map(obj => obj.userRole.roleName);
        if (this.roleArray.includes("Supplier")) this.showSingleSelect = true;
        if (!this.roleArray.includes("Supplier"))
          this.showMultipleSelect = true;
        this.userDataRolesList = this.packagingPropertyOpt.map((obj, key) => ({
          id: key + 1,
          itemName: obj
        }));
        // console.log(this.userRolesList);
        userRolemapping.forEach(role => {
          if (role.userRole.roleId === 4) {
            this.selectedOperationType = role.operationType;
            this.userOperationType = this.getOperationTypeValue(
              this.selectedOperationType
            );
            this.operationTypeDropdown = true;
            if (role.operationType === this.operationTypes[0].displayName) {
              this.suppliercodeDropdown = true;
              this.supplierCodeReqFlag = true;
            }
          }
        });
        this.model.operationType = this.selectedOperationType;
        this.model.userrolemapping = this.roleArray.toString();
        this.model.status = this.user.status;
        this.model.userRolesList = this.getUserRolesListForUser(
          userRolemapping
        );
        this.model.lineNumberRaw = this.user.lineNumbers;
        this.model.supplierCodeRaw = this.user.supplierCode;
        this.model.supplierCodeRawOpmanager = this.getSupplierCodeRawForOMUser(
          this.user.supplierCode,
          true
        );
        this.model.supplierCodeRawNoOpm = this.getSupplierCodeRawForOMUser(
          this.user.supplierCode,
          null
        );
        this.model.supplierCodeRawUpdate = this.getSupplierCodeListForOMUser(
          this.user.supplierCode,
          null
        );
        this.model.deliveryPointRaw = this.user.deliveryPoint;
        // this.model.supplierCode = this.user.supplierCode;
        this.model.supplierCode = this.getSupplierCodeListForUser(
          this.user.supplierCode
        );
        //this.model.linenumber = this.user.lineNumbers;
        this.model.linenumber = this.getLineNumbersForUser(
          this.user.lineNumbers
        );
        if (this.model.linenumber != null)
          this.length = this.model.linenumber.length;
        this.model.groupNumbers = this.user.groupNumbers;
        this.model.SMQ = this.user.supplierManagerQualitys;
        this.model.SMVS = this.user.supplierManagerVendors;
        this.model.Logistics = this.user.logistics;
        this.model.Operations = this.user.operations;
        this.model.operationGroupNumber = this.createGroupIds();
        // Store in variable to be used later
        this.suppCodeApp = this.user.supplierCode;

        if (
          (this.model.SMQ != undefined && this.model.SMQ.length > 0) ||
          (this.model.SMVS != undefined && this.model.SMVS.length > 0) ||
          (this.model.Logistics != undefined &&
            this.model.Logistics.length > 0) ||
          (this.model.Operations != undefined &&
            this.model.Operations.length > 0)
        ) {
          this.userIDTaken = false;
        } else {
          this.userIDTaken = true;
        }
        // let isCopyShow
        for (let i = 0; i < this.packagingPropertyOpt.length; i++) {
          if (this.model.userRolesList.filter(role => role === this.packagingPropertyOpt[i])) {
            this.isCopyShow = true;
          }
        }
        this.initializeData();
      });

    //this.initializeData();
    // this.spinner.hide();
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  onOperationTypeSelect(event) {
    if (this.roleArray.includes("Operation")) {
      if (event === "Select" || event === "") {
        this.opTypeRequired = true;
        this.suppliercodeDropdown = false;
        this.userIDTaken = true;
      }
      if (event === this.operationTypes[1].displayName) {
        this.opTypeRequired = false;
        if (
          this.roleArray.length === 1 ||
          !(
            this.roleArray.includes("SMQ") ||
            this.roleArray.includes("Logistic") ||
            this.roleArray.includes("SMVS") ||
            this.roleArray.includes("Supplier")
          )
        ) {
          this.suppliercodeDropdown = false;
        }
        this.nextProcessRequired = true;

        this.deliveryPointCheck = true;
        this.showOPMSupplierCode = true;
        this.selectedOperationType = event;
        if (
          this.model.lineNumbers !== null ||
          this.model.lineNumbers !== undefined ||
          this.model.lineNumbers.length !== 0
        ) {
          this.userIDTaken = false;
        }
      }
    }
    if (event === this.operationTypes[0].displayName) {
      this.selectedOperationType = event;
      this.suppliercodeDropdown = true;
      this.opTypeRequired = false;
      if (!this.roleArray.includes("Assembly Operator")) {
        this.nextProcessRequired = false;
      }
      this.model.deliveryPoint = [];
      this.deliveryPointCheck = false;
      this.supplierCodeReqFlag = true;
      if (
        this.model.supplierCode !== null ||
        this.model.supplierCode !== undefined ||
        this.model.supplierCode.length !== 0
      ) {
        this.userIDTaken = false;
      }
    }
    this.userOperationType = this.getOperationTypeValue(
      this.selectedOperationType
    );
  }

  getUserRolesListForUser(userroles) {
    let rolesDataList = [];
    this.userDataRolesList.forEach(data => {
      userroles.forEach(role => {
        if (data.itemName === role.userRole.roleName) rolesDataList.push(data);
      });
    });
    return rolesDataList;
  }

  onRoleItemSelect(event) {
    var value = event.itemName;
    this.roleArray.push(value);
    if (value == "Supplier") {
      if (
        this.roleArray.includes("SMQ") ||
        this.roleArray.includes("Logistic") ||
        this.roleArray.includes("SMVS") ||
        this.roleArray.includes("SMQ")
      ) {
        // this.model.supplierCode = [];
        this.supplierCodeReqFlag = true;
        this.suppliercodeDropdown = true;
      }
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.nextProcessRequired = false;
      }
      if (!this.roleArray.includes("Operation")) {
        this.operationTypeDropdown = false;
        this.delPointSuppCodeDropdown = true;
      }
      this.suppliercodeDropdown = true;
      //  this.nextProcessRequired = false;

      //
      this.roleId = 1;
      this.roleName = "Supplier";
      this.system = "Mac";
      // Enable save button
      //  this.userIDTaken = false;
    } else if (value == "SMQ") {
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.nextProcessRequired = false;
      }
      if (!this.roleArray.includes("Operation")) {
        this.operationTypeDropdown = false;
        this.delPointSuppCodeDropdown = true;
      }
      if (!this.roleArray.includes("Supplier")) {
        this.suppliercodeDropdown = true;
      }
      // this.nextProcessRequired = false;

      this.roleId = 2;
      this.roleName = "SMQ";
      this.system = "Mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Logistic") {
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.nextProcessRequired = false;

        this.operationTypeDropdown = false;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      if (!this.roleArray.includes("Supplier")) {
        this.suppliercodeDropdown = true;
      }
      // this.nextProcessRequired = false;

      this.roleId = 3;
      this.roleName = "Logistic";
      this.system = "Mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Operation") {
      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic")
        )
      ) {
        this.operationTypeDropdown = false;
        // this.model.supplierCode = [];
      }

      this.lineCodeList;
      this.groupNumberList;
      // this.suppliercodeDropdown = true;

      this.operationTypeDropdown = true;
      if (
        this.selectedOperationType === "Select" ||
        this.selectedOperationType === ""
      ) {
        this.userIDTaken = true;
      }
      // this.delPointSuppCodeDropdown = false;
      // this.model.suppliercode = [];
      //
      this.roleId = 4;
      this.roleName = "Operation";
      this.system = "mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "SMVS") {
      if (!this.roleArray.includes("Supplier")) {
        this.suppliercodeDropdown = true;
      }

      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.nextProcessRequired = false;

        this.operationTypeDropdown = false;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      // this.suppliercodeDropdown = true;

      //  this.nextProcessRequired = false;

      //
      this.roleId = 7;
      this.roleName = "SMVS";
      this.system = "mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Admin") {
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.nextProcessRequired = false;

        this.operationTypeDropdown = false;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic")
        )
      ) {
        this.suppliercodeDropdown = false;
      }
      this.roleId = 5;
      this.roleName = "Admin";
      this.system = "mac";
      // Enable save button
      //this.userIDTaken = false;
    } else if (value == "SM Admin") {
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.nextProcessRequired = false;

        this.operationTypeDropdown = false;
      }
      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic")
        )
      ) {
        this.suppliercodeDropdown = false;

        //this.model.suppliercode = [];
        //
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      this.roleId = 8;
      this.roleName = "SM admin";
      this.system = "mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Logistic Admin") {
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.nextProcessRequired = false;

        this.operationTypeDropdown = false;
      }
      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic")
        )
      ) {
        this.suppliercodeDropdown = false;

        //this.model.suppliercode = [];
        //
      }
      if (!this.roleArray.includes("Operation"))
        this.deliveryPointCheck = false;

      this.roleId = 9;
      this.roleName = "Logistic Admin";
      this.system = "mac";
      // Enable save button
      //this.userIDTaken = false;
    } else if (value == "Assembly Operator") {
      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic") ||
          (this.roleArray.includes("Operation") &&
            this.selectedOperationType === this.operationTypes[0].displayName)
        )
      ) {
        this.suppliercodeDropdown = false;
        // this.model.supplierCode = [];
        this.userIDTaken = true;
      }

      this.lineCodeList;
      this.groupNumberList;
      // this.suppliercodeDropdown = true;

      this.nextProcessRequired = true;
      // this.operationTypeDropdown = false;
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      // this.model.suppliercode = [];
      //
      this.roleId = 10;
      this.roleName = "assemblyOperator";
      this.system = "mac";
      // Enable save button
      // this.userIDTaken = false;
    } else if (value == "Level-4 Manager") {
      this.suppliercodeDropdown = false;
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.nextProcessRequired = false;

        this.operationTypeDropdown = false;
      }
      // this.model.supplierCode = [];
      this.roleId = 12;
      this.roleName = "l4Manager";
      this.system = "mac";
      // Disable save button
      // this.userIDTaken = false;
      // this.userIDTaken = false;
    } else if (value == "LSP") {
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.nextProcessRequired = false;

        this.operationTypeDropdown = false;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;

      if (
        !(
          this.roleArray.includes("Supplier") ||
          this.roleArray.includes("SMQ") ||
          this.roleArray.includes("SMVS") ||
          this.roleArray.includes("Logistic")
        )
      ) {
        this.suppliercodeDropdown = false;

        //this.model.suppliercode = [];
        //
      }
      //
      //

      //this.suppliercodeDropdown = true;

      //this.nextProcessRequired = false;

      //this.model.suppliercode = [];
      //
      this.roleId = 13;
      this.roleName = "LSP";
      this.system = "mac";
      // Disable save button
      // this.userIDTaken = false;
      // this.userIDTaken = false;
    } else if (value == "Reader") {
      if (
        !(
          this.roleArray.includes("Operation") ||
          this.roleArray.includes("Assembly Operator")
        )
      ) {
        this.nextProcessRequired = false;

        this.operationTypeDropdown = true;
      }
      if (!this.roleArray.includes("Operation"))
        this.delPointSuppCodeDropdown = true;
      //
      //

      //this.suppliercodeDropdown = true;

      //this.nextProcessRequired = false;

      //this.model.suppliercode = [];
      //
      this.roleId = 15;
      this.roleName = "Reader";
      this.system = "mac";
    }
    // if (this.roleArray.length === 0) this.userIDTaken = true;
  }

  onRoleDeSelectAll(event) {
    this.suppliercodeDropdown = false;
    this.model.lineNumbers = [];
    this.model.linenumber = null;
    this.model.operationType = "Select";
    this.selectedOperationType = "Select";
    this.nextProcessRequired = false;
    this.operationTypeDropdown = false;
    this.deliveryPointCheck = false;
    this.nextProcessRequired = false;
    this.model.supplierCode = [];
    this.suppliercodeDropdown = false;
    this.supplierCodeReqFlag = false;
    this.roleArray = [];
    this.model.supplierCodeRawUpdate = [];
    this.userIDTaken = true;
  }

  onRoleSelectAll(event) {
    this.roleArray = [];
    event.forEach(item => {
      this.onRoleItemSelect(item);
    });
  }

  OnRoleItemDeSelect(event) {
    var index1 = this.roleArray.indexOf(event.itemName);
    this.roleArray.splice(index1, 1);

    if (event.itemName === "Operation") {
      this.opTypeRequired = false;
      this.operationTypeDropdown = false;
      this.selectedOperationType = "Select";
      this.model.operationType = "Select";
    }
    // if (event.itemName === "Assembly Operator") {
    //   this.model.lineNumbers = null;
    //   this.nextProcessRequired = false;
    //   this.operationTypeDropdown = false;
    // }
    if (
      !(
        this.roleArray.includes("Operation") ||
        this.roleArray.includes("Assembly Operator")
      )
    ) {
      this.model.lineNumbers = null;
      this.nextProcessRequired = false;
      this.operationTypeDropdown = false;
    }
    if (!this.roleArray.includes("Operation")) {
      this.deliveryPointlink = [];
      this.delPointSuppCodeDropdown = true;
      this.deliveryPointCheck = false;
      // this.operationTypeDropdown=true;
    }
    if (
      !(
        this.roleArray.includes("Supplier") ||
        this.roleArray.includes("SMQ") ||
        this.roleArray.includes("Logistic") ||
        this.roleArray.includes("SMVS")
      )
    ) {
      this.model.supplierCode = [];

      if (
        this.roleArray.includes("Operation") &&
        this.selectedOperationType === this.operationTypes[0].displayName
      ) {
        this.supplierCodeReqFlag = true;
        // this.nextProcessRequired = false;

        this.suppliercodeDropdown = true;
      } else {
        this.supplierCodeReqFlag = false;
        // this.nextProcessRequired = true;
        this.suppliercodeDropdown = false;
      }
    }
    if (this.roleArray.length === 0) {
      this.model.supplierCode = [];
      this.model.lineNumbers = null;
      this.model.deliveryPoint = [];
      this.model.operationType = "Select";
      this.suppliercodeDropdown = false;
      this.nextProcessRequired = false;
      this.model.supplierCodeRawUpdate = [];
      this.userIDTaken = true;
    }
  }

  getSupplierCodeListForUser(supplierCodes) {
    let supplierCodeArray = [];
    let filteredSupplierCodes = supplierCodes.filter(
      obj => obj.isOperationManager != true
    );
    filteredSupplierCodes.forEach(sc => {
      supplierCodeArray.push(sc.supplierCode);
    });
    return supplierCodeArray;
  }
  getDeliveryPointForUser(deliveryPoint) {
    let deliveryPointsNames = [];
    deliveryPointsNames = deliveryPoint.map(obj => obj.deliveryPoint);
    let deliveryPointreturn = [];
    let deliveryPointdropdownvalue = this.deliveryPointList;
    deliveryPointsNames.forEach(function (value, key) {
      let index = deliveryPointdropdownvalue.find(x => x.itemName === value);
      deliveryPointreturn.push({ id: index ? index.id : "", itemName: value });
    });
    return deliveryPointreturn;
  }

  getSupplierCodeListForOMUser(supplierCodes, oprMgr) {
    let supplierCodeArray = [];
    let filteredSupplierCodes = supplierCodes.filter(
      obj => obj.isOperationManager == oprMgr
    );
    filteredSupplierCodes.forEach(sc => {
      supplierCodeArray.push(sc.supplierCode);
    });
    return supplierCodeArray;
  }

  getSupplierCodeRawForOMUser(supplierCodes, status) {
    var filteredSupplierCodes = supplierCodes.filter(
      obj => obj.isOperationManager == status
    );
    return filteredSupplierCodes;
  }
  getLineNumbersForUser(lineNumber) {
    let lineNumbers = lineNumber.map(ln => ln.lineNumber);
    return lineNumbers;
  }
  getGroupIds() {
    if (
      this.model.operationGroupNumber != null &&
      this.model.operationGroupNumber.length > 0
    ) {
      let itemArray = [];
      for (
        let index = 0;
        index < this.model.operationGroupNumber.length;
        index++
      ) {
        itemArray.push(this.model.operationGroupNumber[index].itemName);
      }
      return itemArray;
    }
  }

  createGroupIds() {
    if (
      this.model.operationGroupNumber != null &&
      this.model.operationGroupNumber != undefined &&
      this.model.operationGroupNumber.length > 0
    ) {
      let groupIds = [];
      let i = 0;
      this.model.operationGroupNumber.forEach(function (value, key) {
        groupIds.push({ id: key, itemName: value });
        i++;
      });
      return groupIds;
    }
  }

  fnameChange(newValue) {
    if (newValue.length > 0) {
      this.userIDTaken = false;
      this.savedisabledSMADmin = false;
    }
  }

  lnameChange(newValue) {
    if (newValue.length > 0) {
      this.userIDTaken = false;
      this.savedisabledSMADmin = false;
    }
  }

  phoneNumber3(newValue) {
    if (newValue.length > 0) {
      this.userIDTaken = false;
      this.savedisabledSMADmin = false;
    }
  }
  phoneNumber(newValue) {
    if (newValue.length > 0) {
      this.userIDTaken = false;
      this.savedisabledSMADmin = false;
    }
  }

  phoneNumber2(newValue) {
    if (newValue.length > 0) {
      this.userIDTaken = false;
      this.savedisabledSMADmin = false;
    }
  }

  emailChange(newValue) {
    if (newValue.length > 0) {
      this.userIDTaken = false;
      this.savedisabledSMADmin = false;
    }
  }

  initializeData() {
    // get supplier code
    this.userService.getSupplierMasterData().subscribe(result => {
      this.supplierCodes = result.response;
      var suppCodeArr = [];
      let i = 0;
      this.supplierCodes.forEach(function (value, key) {
        suppCodeArr.push({ id: key, itemName: value.supplierCode });
        i++;
      });

      this.suppCodeList = suppCodeArr.sort(this.dynamicSort("itemName"));
      // let deliveryPointlistItem=[];
      //get delivery points
      this.userService.getDeliveryPoints().subscribe(result => {
        this.deliveryPointlistItem = result.response;
        var deliveryPointArr = [];
        this.deliveryPointlistItem.forEach(function (value, key) {
          deliveryPointArr.push({ id: key, itemName: value.deliveryPoint });
        });
        this.deliveryPointList = deliveryPointArr;
        this.model.deliveryPoint = this.getDeliveryPointForUser(
          this.user.deliveryPoint
        );
        this.deliveryPointsHideArray = this.model.deliveryPoint;
        if (this.deliveryPointsHideArray.length > 0)
          this.deliveryPointCheck = true;
      });

      this.userService
        .singlegetUserDetails(this.userDetails)
        .subscribe(result => {
          //Get parts data from URL and bind in form fields
          var userResult = result.response;
          //this.userNewResult=result.response;
          this.suppCodeSelect = this.getSupplierCodeListForUser(
            userResult.supplierCode
          );
          this.suppCodeOPMSelect = this.getSupplierCodeListForOMUser(
            userResult.supplierCode,
            true
          );

          // To set selected items
          var selectSuppCode = [];
          if (this.suppCodeSelect != null) {
            this.suppCodeSelect.forEach(function (value, key) {
              var index = suppCodeArr.find(x => x.itemName === value);
              selectSuppCode.push({
                id: index ? index.id : "",
                itemName: value
              });
              i++;
            });
            this.model.supplierCode = selectSuppCode;
          }

          var selectSuppCodeOpm = [];
          if (this.suppCodeOPMSelect != null) {
            this.suppCodeOPMSelect.forEach(function (value, key) {
              var index = suppCodeArr.find(x => x.itemName === value);
              selectSuppCodeOpm.push({
                id: index ? index.id : "",
                itemName: value
              });
              i++;
            });
            this.model.supplierCodeOpm = selectSuppCodeOpm;
          }
        });
      this.spinner.hide();
    });

    this.userService.getLineNumbers().subscribe(result => {
      this.lineCodes = result.response;
      var lineCodeListArr = [];
      this.lineCodes.forEach(function (value, key) {
        lineCodeListArr.push({ id: key + 1, itemName: value.lineNumber });
      });

      this.lineCodeList = lineCodeListArr;

      var selectLineNo = [];
      if (
        this.model.userrolemapping != "Admin" &&
        this.user.lineNumbers != undefined &&
        this.user.lineNumbers != null
      ) {
        this.user.lineNumbers.forEach(function (value, key) {
          var index = lineCodeListArr.find(
            x => x.itemName === value.lineNumber
          );
          selectLineNo.push({ id: index.id, itemName: value.lineNumber });
        });
        this.model.lineNumbers = selectLineNo;
      }
    });

    //Get Group Number
    /*this.userService.getGroupNumberMasterData().subscribe(result => {
      this.groupNumbers = result.response;
      let groupNumberListArr = [];
      this.groupNumbers.forEach(function (value, key) {
        groupNumberListArr.push({ id: key + 1, itemName: value.groupNumber });
      });

      this.groupNumberList = groupNumberListArr;
      let selectedID = [];
      if (this.user != undefined && this.user.groupNumbers != null) {
        this.user.groupNumbers.forEach(function (value, key) {
          var index = groupNumberListArr.find(x => x.itemName === value);
          selectedID.push({ id: index.id, itemName: value });
        });
        this.model.groupNumbers = selectedID;
      }

    });*/

    this.userService.registerL4Users().subscribe(result => {
      this.SMQList = result.response.SMQ;
      this.SMVSList = result.response.SMVS;
      this.LogisticsList = result.response.LOGISTICS;
      this.operationsList = result.response.OPERATION;
      //to get and display selected SMQ
      var SMQArray = [];
      this.SMQList.forEach(function (value, key) {
        SMQArray.push({
          id: key + 1,
          itemName: value.loginId,
          firstName: value.loginId,
          lastName: value.lastName
        });
      });
      this.SMQUsers = SMQArray;
      var selectedSMQ = [];
      if (
        this.user !== undefined &&
        this.user.supplierManagerQualitys != null &&
        this.user.supplierManagerQualitys != undefined
      ) {
        this.user.supplierManagerQualitys.forEach(function (value, key) {
          var index = SMQArray.find(x => x.itemName === value);
          selectedSMQ.push({
            id: index.id,
            itemName: index.itemName,
            firstName: index.firstName,
            lastName: index.lastName
          });
        });
        this.model.SMQ = selectedSMQ;
      }

      //to get and display selected SMVS
      var SMVSArray = [];
      this.SMVSList.forEach(function (value, key) {
        SMVSArray.push({
          id: key + 1,
          itemName: value.loginId,
          firstName: value.loginId,
          lastName: value.lastName
        });
      });
      this.SMVSUsers = SMVSArray;
      var selectedSMVS = [];
      if (
        this.user.supplierManagerVendors != null &&
        this.user.supplierManagerVendors != undefined
      ) {
        this.user.supplierManagerVendors.forEach(function (value, key) {
          var index = SMVSArray.find(x => x.itemName === value);
          selectedSMVS.push({
            id: index.id,
            itemName: index.itemName,
            firstName: index.firstName,
            lastName: index.lastName
          });
        });
        this.model.SMVS = selectedSMVS;
      }

      //to get and display selected Logistics
      var LogisticsArray = [];
      this.LogisticsList.forEach(function (value, key) {
        LogisticsArray.push({
          id: key + 1,
          itemName: value.loginId,
          firstName: value.loginId,
          lastName: value.lastName
        });
      });
      this.LogisticsUsers = LogisticsArray;
      var selectedLogistics = [];
      if (this.user.logistics != null && this.user.logistics != undefined) {
        this.user.logistics.forEach(function (value, key) {
          var index = LogisticsArray.find(x => x.itemName === value);
          selectedLogistics.push({
            id: index.id,
            itemName: index.itemName,
            firstName: index.firstName,
            lastName: index.lastName
          });
        });
        this.model.Logistics = selectedLogistics;
      }

      //to get and display selected Operations
      var operationsArray = [];
      if (this.operationsList != null && this.operationsList != undefined) {
        this.operationsList.forEach(function (value, key) {
          operationsArray.push({
            id: key + 1,
            itemName: value.loginId,
            firstName: value.loginId,
            lastName: value.lastName
          });
        });
        this.operationsUsers = operationsArray;
      }

      var selectedOperations = [];
      if (this.user.operations != null) {
        this.user.operations.forEach(function (value, key) {
          var index = operationsArray.find(x => x.itemName === value);
          selectedOperations.push({
            id: index.id,
            itemName: index.itemName,
            firstName: index.firstName,
            lastName: index.lastName
          });
        });
        this.model.Operations = selectedOperations;
      }
    });
  }

  dynamicSort(property) {
    var sortOrder = 1;

    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }

    return function (a, b) {
      if (sortOrder == -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    };
  }

  checkUserRolesList(rolesList) {
    for (let i = 0; i < rolesList.length; i++) {
      if (rolesList[i].itemName === "Operation") {
        this.supplierCodeReqFlag = true;
      }
    }
  }

  valuechange(newValue) {
    this.model.lineNumbers = newValue;
    this.userIDTaken = false;
    if (newValue.length > 0) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
  }
  valuechangeSMQ(value) {
    this.model.SMQ = value;
    this.userIDTaken = false;
    if (value.length > 0) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
    if (
      this.model.SMQ.length > 0 ||
      this.model.SMVS.length > 0 ||
      this.model.Logistics.length > 0 ||
      this.model.Operations.length > 0
    ) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
  }

  valuechangeSMVS(value) {
    this.model.SMVS = value;
    this.userIDTaken = false;
    if (value.length > 0) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
    if (
      this.model.SMQ.length > 0 ||
      this.model.SMVS.length > 0 ||
      this.model.Logistics.length > 0 ||
      this.model.Operations.length > 0
    ) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
  }

  valuechangeLogistics(value) {
    this.model.Logistics = value;
    this.userIDTaken = false;
    if (value.length > 0) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
    if (
      this.model.SMQ.length > 0 ||
      this.model.SMVS.length > 0 ||
      this.model.Logistics.length > 0 ||
      this.model.Operations.length > 0
    ) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
  }
  valuechangeOperations(value) {
    this.model.Operations = value;
    if (value.length > 0) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
    if (
      this.model.SMQ.length > 0 ||
      this.model.SMVS.length > 0 ||
      this.model.Logistics.length > 0 ||
      this.model.Operations.length > 0
    ) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
  }
  valuechangeSupplierCode(newValue) {
    this.model.supplierCode = newValue;
    // this.userIDTaken = false;
    if (newValue.length > 0) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
  }

  valuechangeSupplierCodeOPM(newValue) {
    this.model.supplierCodeOpm = newValue;
    // this.userIDTaken = false;
    if (newValue.length > 0) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
  }

  valuechangeDeliveryPointOPM(newValue) {
    this.model.deliveryPoint = newValue;
    this.userIDTaken = false;
    if (newValue.length > 0) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
  }

  closeLookup() {
    this.displayUntagAlert = false;
  }
  //Change on Group number dropdown
  valuechangeOnGroupNumber(newValue) {
    this.model.groupNumbers = newValue;
    this.userIDTaken = false;
    if (newValue.length > 0) {
      this.userIDTaken = false;
    } else {
      this.userIDTaken = true;
    }
  }

  // Operation Role Group Number
  onSingleOPGNo(groupNumber: any) {
    this.featchGroupNumberValue();
  }

  onDeSelecOPGNo(yes: any) {
    this.featchGroupNumberValue();
  }

  onSelectAllOPGNo(yes: any) {
    this.featchGroupNumberValue();
  }

  onDeSelectAllOPGNo(yes: any) {
    this.featchGroupNumberValue();
  }

  featchGroupNumberValue() {
    let groupid = this.getGroupIds();
    let suppListNumber = [];
    this.userService.getLineNumberbyGroupNumber(groupid).subscribe(
      data => {
        let res: any;
        res = data;
        suppListNumber = [];
        res.response.forEach(function (value, key) {
          suppListNumber.push({ id: key + 1, itemName: value });
        });
        this.model.lineNumbers = suppListNumber;
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
      }
    );
  }

  postFormError() {
    this.toastr.warning(this.translate.instant("NETWORK_STATUS_ISSUE"));
  }

  registerationSuccess() {
    //this.toastr.success("User Updation Successfull");
    this.modalRef = this.modalService.open(this.userUpdation,{backdrop:false});
    this.modalRef.result.then(result => { });
  }

  register() {
    this.spinner.show();
    let registerData = {
      loginId: this.model.loginId,
      userStatus: this.model.status,
      phoneNumber: this.model.phone,
      companyname: this.model.companyname,
      empId: this.model.employeeId
    };

    var suppCode = [];
    /*if (this.model.supplierCode) {
      this.model.supplierCode.forEach(function (value, key) {
        suppCode.push(value.itemName);
      });
    }*/

    if (this.model.supplierCode) {
      this.model.supplierCode.forEach(scObj => {
        let supplierCodeRawObj = this.model.supplierCodeRawNoOpm.find(
          x => x.supplierCode === scObj.itemName
        );
        suppCode.push({
          userSupplierCodeId: supplierCodeRawObj
            ? supplierCodeRawObj.userSupplierCodeId
            : "",
          supplierCode: scObj.itemName
        });
      });
    }

    var suppCodeOpm = [];
    if (this.model.supplierCodeOpm) {
      this.model.supplierCodeOpm.forEach(scObj => {
        let supplierCodeRawObj = this.model.supplierCodeRawOpmanager.find(
          x => x.supplierCode === scObj.itemName
        );
        suppCodeOpm.push({
          userSupplierCodeId: supplierCodeRawObj
            ? supplierCodeRawObj.userSupplierCodeId
            : "",
          supplierCode: scObj.itemName,
          isOperationManager: true
        });
      });
    }

    var deliveryPointOpm = [];
    if (this.model.deliveryPoint) {
      this.model.deliveryPoint.forEach(scObj => {
        let deliveryPointRawObj = this.model.deliveryPointRaw.find(
          x => x.deliveryPoint == scObj.itemName
        );
        deliveryPointOpm.push({
          mappingId: deliveryPointRawObj ? deliveryPointRawObj.mappingId : "",
          deliveryPoint: scObj.itemName
        });
      });
    }

    if (this.model.lineNumbers) {
      var lineNos = [];
      var lineRaw1 = this.model.lineNumberRaw;
      this.model.lineNumbers.forEach(function (value, key) {
        let index = lineRaw1.find(x => x.lineNumber == value.itemName);
        lineNos.push(
          index != undefined
            ? {
              userLineNumberId: index.userLineNumberId,
              lineNumber: value.itemName
            }
            : { lineNumber: value.itemName }
        );
      });
    }

    //Group Number Value push
    if (this.model.groupNumbers) {
      var selectedGroupNumbers = [];
      this.model.groupNumbers.forEach(function (value, key) {
        selectedGroupNumbers.push(value.itemName);
      });
    }

    if (this.model.SMQ) {
      var SMQDataToSend = [];
      this.model.SMQ.forEach(function (value, key) {
        SMQDataToSend.push(value.itemName);
      });
    }
    if (this.model.SMVS) {
      var SMVSDataToSend = [];
      this.model.SMVS.forEach(function (value, key) {
        SMVSDataToSend.push(value.itemName);
      });
    }
    if (this.model.Logistics) {
      var LogisticsDataToSend = [];
      this.model.Logistics.forEach(function (value, key) {
        LogisticsDataToSend.push(value.itemName);
      });
    }
    if (this.model.Operations) {
      var OperationsDataToSend = [];
      this.model.Operations.forEach(function (value, key) {
        OperationsDataToSend.push(value.itemName);
      });
    }

    var dataToSend = {
      companyname: this.model.companyname,
      lineNumbers: lineNos,
      groupId: selectedGroupNumbers,
      loginId: this.model.loginId,
      phoneNumber: this.model.phone,
      supplierCode: suppCode,
      operationSupplierCode: suppCodeOpm,
      deliveryPoint: deliveryPointOpm,
      userStatus: this.model.status,
      supplierManagerQualitys: SMQDataToSend,
      supplierManagerVendors: SMVSDataToSend,
      logistics: LogisticsDataToSend,
      operations: OperationsDataToSend,
      emailId: this.model.emailId,
      opGroupIds: this.getGroupIds(),
      firstName: this.model.firstName,
      lastName: this.model.lastName,
      operationType: this.selectedOperationType,
      userRoleMappings: this.getRolArrayForSelctedRole()
    };
    this.userService.updateUserDetails(dataToSend).subscribe(
      data => {
        this.userAccess = false;
        this.router.navigate(["/um"]);
        this.spinner.hide();
        this.registerationSuccess();
      },
      error => {
        this.postFormError();
        this.spinner.hide();
      }
    );
  }

  cacheUserDetails(cacheDetails) {
    this.modalRef = this.modalService.open(cacheDetails);
    this.modalRef.result.then(result => { });
  }

  replicaCurrentUser() {
    let cacheUser = {
      role: this.model.userRolesList,
      suppliercode:
        this.model.supplierCode != null && this.model.supplierCode.length > 0
          ? this.model.supplierCode
          : [],
      lineNumbers:
        this.model.lineNumbers != null && this.model.lineNumbers.length > 0
          ? this.model.lineNumbers
          : [],
      Logistics:
        this.model.Logistics != null && this.model.Logistics.length > 0
          ? this.model.Logistics
          : [],
      Operations:
        this.model.Operations != null && this.model.Operations.length > 0
          ? this.model.Operations
          : [],
      SMQ:
        this.model.SMQ != null && this.model.SMQ.length > 0
          ? this.model.SMQ
          : [],
      SMVS:
        this.model.SMVS != null && this.model.SMVS.length > 0
          ? this.model.SMVS
          : []
    };

    localStorage.setItem("cacheUser", JSON.stringify(cacheUser));
    this.modalRef.close();
    this.router.navigate(["register"]);
  }

  getRolArrayForSelctedRole() {
    let roleObjArray = [];
    this.roleArray.forEach(roledata => {
      let roledataObj = {
        roleId: this.getRoleId(roledata),
        roleName: roledata,
        system: "Mac"
      };
      roleObjArray.push(roledataObj);
    });
    return roleObjArray;
  }

  getRoleId(value) {
    switch (value) {
      case "Supplier":
        return 1;
      case "SMQ":
        return 2;
      case "Logistic":
        return 3;
      case "Operation":
        return 4;
      case "Admin":
        return 5;
      case "SMVS":
        return 7;
      case "SM Admin":
        return 8;
      case "Logistic Admin":
        return 9;
      case "Assembly Operator":
        return 10;
      case "Level-4 Manager":
        return 12;
      case "LSP":
        return 13;
      case "Reader":
        return 15;
      default:
        break;
    }
  }

  getOperationTypeValue(name) {
    if (name === this.operationTypes[0].displayName)
      return this.operationTypes[0].value;
    if (name === this.operationTypes[1].displayName)
      return this.operationTypes[1].value;
  }

  close() {
    this.modalRef.close();
  }
}
